var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0417 23.7285H25.8542V20.541C25.8542 19.9602 25.3725 19.4785 24.7917 19.4785C24.2109 19.4785 23.7292 19.9602 23.7292 20.541V23.7285H20.5417C19.9609 23.7285 19.4792 24.2102 19.4792 24.791C19.4792 25.3718 19.9609 25.8535 20.5417 25.8535H23.7292V29.041C23.7292 29.6218 24.2109 30.1035 24.7917 30.1035C25.3725 30.1035 25.8542 29.6218 25.8542 29.041V25.8535H29.0417C29.6225 25.8535 30.1042 25.3718 30.1042 24.791C30.1042 24.2102 29.6225 23.7285 29.0417 23.7285Z",
    fill: "#00A4D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.1667 12.0707V5.63898C31.1667 3.64148 30.26 2.83398 28.0075 2.83398H22.2842C20.0317 2.83398 19.125 3.64148 19.125 5.63898V12.0565C19.125 14.0682 20.0317 14.8615 22.2842 14.8615H28.0075C30.26 14.8757 31.1667 14.0682 31.1667 12.0707Z",
    fill: "#00A4D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 12.0707V5.63898C14.875 3.64148 13.9683 2.83398 11.7158 2.83398H5.99248C3.73998 2.83398 2.83331 3.64148 2.83331 5.63898V12.0565C2.83331 14.0682 3.73998 14.8615 5.99248 14.8615H11.7158C13.9683 14.8757 14.875 14.0682 14.875 12.0707Z",
    fill: "#00A4D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.875 28.0075V22.2842C14.875 20.0317 13.9683 19.125 11.7158 19.125H5.99248C3.73998 19.125 2.83331 20.0317 2.83331 22.2842V28.0075C2.83331 30.26 3.73998 31.1667 5.99248 31.1667H11.7158C13.9683 31.1667 14.875 30.26 14.875 28.0075Z",
    fill: "#00A4D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCategoryIcon);
export default __webpack_public_path__ + "static/media/addCategoryIcon.c64eaa0436b228032cb1182dc00873d0.svg";
export { ForwardRef as ReactComponent };